import { TypesWithLevelData as t } from "../../3d/level-config/index2.js";
function r(e) {
  return t.includes(e.type) ? e.data.level : e.parent ? r(e.parent) : void 0;
}
export {
  r as getLevel
};
//# sourceMappingURL=index4.js.map
